export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.7-1224.43",
  commitId: "0bfce04412cfb21e4ba474c8f74ff98c2f30e160",
  commitTime: "2026-08-07T12:24:43.000Z",
});
